module.exports = __webpack_public_path__ + "static/media/05_Mascotte_canicule.5da96fd4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/05_Mascotte_canicule.svg
// module id = 761
// module chunks = 0